import React from 'react'
import ReactDOM from 'react-dom'

import 'url-search-params-polyfill'

import { updateSubscriptionData } from '../Landing/Helper/helper.js'
import { isLoggedIntoSubscriptionCenter } from '../../../global/authentication/authentication-manager.js'
import {
  getSubscriptionsByName,
  getSubscriptionsForUser,
} from '../Data/SubscriptionCenterDataSource.js'
import CategorySubscriptionButton from './CategorySubscriptionButton.jsx'

class CategorySubscriptionButtonElement extends HTMLElement {
  async connectedCallback() {
    let subscriptionProfile

    let subscriptions = []
    let categoryName = this.dataset.category
    let buttonNotClickedText = this.dataset.buttonNotClickedText
    let buttonClickedText = this.dataset.buttonClickedText
    let productSubscribe = this.dataset.productSubscribe
    if (categoryName) {
      const categorySubscription = await getSubscriptionsByName(categoryName)

      if (isLoggedIntoSubscriptionCenter()) {
        if (categorySubscription.length > 0) {
          subscriptionProfile = await getSubscriptionsForUser()
          subscriptions = updateSubscriptionData(subscriptionProfile.value, {
            subscriptions: categorySubscription,
          })
        }
      } else {
        subscriptions = categorySubscription
      }
    }

    const reactContainerId =
      'email-subscription-center-modal-react-app' + Math.random()
    let reactContainer = document.createElement('span')
    reactContainer.setAttribute('id', reactContainerId)
    this.appendChild(reactContainer)

    ReactDOM.render(
      <>
        {
          <CategorySubscriptionButton
            subscriptionProfile={subscriptionProfile}
            categorySubscription={subscriptions[0]}
            buttonNotClickedText={buttonNotClickedText}
            buttonClickedText={buttonClickedText}
            productSubscribe={productSubscribe}
          />
        }
      </>,
      document.getElementById(reactContainerId)
    )
  }
}
if (!customElements.get('category-subscription-button')) {
  customElements.define(
    'category-subscription-button',
    CategorySubscriptionButtonElement
  )
}
